import { useEffect, useState } from 'react';
import type { WorkListFilter } from '../../../../../common/enums/workListFilter';
import type { IService } from '../../../interfaces/service';
import type { ISearchFilter } from './RequestsListHeader';
import { UrlBuilder } from '../../../../../common/utils/urlBuilder';
import { translateKey } from '../../../../translate';
import { useAbortableFetch } from '../../../../utils/hooks/useAbortableFetch';
import { DropdownAsyncLoadInput } from '../../../fields/DropdownAsyncLoad';

export interface IRequestListServiceFilterProps {
    onSearchFilterChange: (searchFilter: ISearchFilter) => Promise<void>;
    searchFilter: ISearchFilter;
    workListFilter: WorkListFilter;
}

export function RequestListServiceFilter(props: IRequestListServiceFilterProps) {
    const abortableFetch = useAbortableFetch();
    const [services, setServices] = useState<IService[]>([]);

    useEffect(() => {
        loadServices();
    }, [props.workListFilter]);

    return (
        <DropdownAsyncLoadInput
            loadOptions={async (searchTerm) => filterServices(searchTerm)}
            onChange={async (value) => await props.onSearchFilterChange({ ...props.searchFilter, serviceId: value })}
            placeholder={translateKey('common.filterOnService') + '...'}
            refreshToken={
                'refresh' +
                services
                    .map((service) => {
                        return service.code;
                    })
                    .join('')
            }
            value={props.searchFilter.serviceId}
        />
    );

    function filterServices(text: string) {
        let filteredServices = services;
        if (text) {
            filteredServices = services.filter(
                (service) =>
                    service.name.toLowerCase().includes(text.toLowerCase()) ||
                    service.code.toLowerCase().includes(text.toLowerCase())
            );
        }

        return filteredServices.map((service) => ({ value: service.id, label: service.name }));
    }

    async function loadServices() {
        const urlBuilder = new UrlBuilder('/api/services/related');
        urlBuilder.add('workListFilter', props.workListFilter);
        const url = urlBuilder.build();
        const result = await abortableFetch.getJson(url);
        setServices(result.json.items);
    }
}
